import { css, cx } from '@emotion/css';
import { useMemoizedFn } from 'ahooks';
import { Button, Drawer, DrawerProps } from 'antd';
import { FormInstance } from 'antd/es/form';
import ForwardFormInstance from 'components/ForwardFormInstance';
import { useRef } from 'react';
import { useTranslate } from '@tolgee/react';
import { FooterWrapper } from '../../RoleDetail/RoleDetailFormDrawer';
import DepartmentAccountDetailForm, {
  DepartmentAccountDetailFormProps,
} from './DepartmentAccountDetailForm';

export interface DepartmentAccountDetailFormDrawerProps extends DrawerProps {
  formProps: Omit<DepartmentAccountDetailFormProps, 'form'>;
}

const DepartmentAccountDetailFormDrawer = (props: DepartmentAccountDetailFormDrawerProps) => {
  const { formProps, className, onClose, ...otherProps } = props;
  const { t } = useTranslate();
  const formRef = useRef<FormInstance>(null);
  /**
   * 提交表单
   */
  const submitForm = useMemoizedFn(() => {
    if (formRef.current) {
      formRef.current.submit();
    }
  });
  return (
    <Drawer
      width={1200}
      className={cx(
        css`
          .ant-drawer-content-wrapper {
            max-width: 100vw;
          }
        `,
        className,
      )}
      onClose={onClose}
      footer={
        <FooterWrapper>
          <Button type="primary" onClick={submitForm}>
            {formProps.initialValues === undefined
              ? t('department.确认添加')
              : t('modals.确认修改')}
          </Button>
          <Button onClick={(e) => onClose && onClose(e as any)}>{t('translation.取消')}</Button>
        </FooterWrapper>
      }
      {...otherProps}
    >
      <ForwardFormInstance ref={formRef}>
        {(form) => {
          return <DepartmentAccountDetailForm {...formProps} form={form} />;
        }}
      </ForwardFormInstance>
    </Drawer>
  );
};
export default DepartmentAccountDetailFormDrawer;
